module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_5_ECOSISTEMICO.42cb7940.jpg";